import Events from "./events";
import Swal from "sweetalert2";

window.goToWhatsApp = phoneNumber => {
    window.open('https://api.whatsapp.com/send?phone=' + phoneNumber, '_blank');
}

Vue.prototype.$dispatch = window.$dispatch = (ev, params = {}) => {
    document.dispatchEvent(new CustomEvent(ev, {detail: params}))
}
Vue.prototype.$listen = window.$listen = (ev, callback) => {
    let listener = data => callback(data.detail);
    document.addEventListener(ev, listener)
    return listener
}
Vue.prototype.$removeListener = window.$removeListener = (ev, callback) => {
    document.removeEventListener(ev, callback)
}

window.refreshUser = () => {
    axios.get('/api/profile', {params: {token: window.jwt_token}})
        .then(resp => {
            console.log(resp.data)
            window.$dispatch(Events.USER_UPDATED, resp.data)
            _.forEach(resp.data, (value, key) => window.user[key] = value)
        })
}

window.raw = input => JSON.parse(JSON.stringify(input))

Vue.prototype.$dispatch = window.$dispatch = (ev, params = {}) => {
    document.dispatchEvent(new CustomEvent(ev, {detail: params}))
}

window.subscriptionRequired = () => Swal.fire({
    title: 'Attention',
    text: window.text.can_send_message_feature_error,
    icon: 'warning',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Upgrade',
    cancelButtonText: 'Cancel',
    /* confirmButtonClass: 'btn btn-success',
     cancelButtonClass: 'btn btn-danger',*/
    buttonsStyling: true,
    closeOnConfirm: false,
    closeOnCancel: false
}).then((result) => {
    if (result.value) {
        window.location = '/select-plan'
    }
})
